import React, { useState } from 'react';
import { createDrawerNavigator, DrawerContentScrollView } from '@react-navigation/drawer'; // +
import { useSelector } from 'react-redux';
import i18n from 'i18n-js';

import Home from '../screens/Home';
import Contacts from '../screens/Contacts';
import Channels from '../screens/Channels';
import Community from '../screens/Community';
import Blank from '../../screens/Blank';
import HelpModal from '../screens/HelpModal';
import ModalAdmin from '../../screens/modals/ModalAdmin';
import LegalTabs from '../screens/LegalTabs';
// import WelcomeModal from "../screens/WelcomeModal";
import AppView from './AppView';
import { IconM } from '@/components/media/IconsV2';
import { Pressable } from '@/components/ui/pressable';
import { HStack } from '@/components/ui/hstack';
import { Text } from '@/components/ui/text';
import { VStack } from '@/components/ui/vstack';
import { Box } from '@/components/ui/box';
import { View } from 'react-native';

const SideBar = createDrawerNavigator();

export default function SideNavigationBar({ navigation }) {
    const internal = useSelector((state) => state.settings.preview)

    // const [showWelcomeModal, setShowWelcomeModal] = useState(false) // !settings.dontShowStudioWelcome
    const [showHelpModal, setShowHelpModal] = useState(false);

    function CustomDrawerContent(props) {
        const getIcon = (screenName) => {
            switch (screenName) {
                case 'home':
                    return 'format-list-bulleted';
                case 'contacts':
                    return 'group';
                // return 'contacts';
                case 'channels':
                    return 'campaign';
                case 'planner':
                    return 'event-available';
                case 'community':
                    return 'groups-2';
                case 'statistics':
                    return 'analytics';
                case 'admin':
                    return 'construction';
                default:
                    return undefined;
            }
        };

        const navigate = (name) => {
            switch (name) {
                case 'admin':
                    props.navigation.navigate('AppView', {
                        screen: 'MainStack',
                        params: { screen: 'ModalAdmin', params: {} }
                    });
                    break;
                default:
                    props.navigation.navigate(name);
            }
        };

        const renderSideMenuItem = ({ name, is_nested, is_active, is_active_parent }, index) => {
            return (
                <Pressable key={`${name}_${index}`} onPress={() => navigate(name)} className={`${is_active || is_active_parent ? 'bg-primary-50' : 'transparent'}`}>
                    <View className="py-4" style={{ paddingLeft: is_nested ? 44 : 12 }}>
                        <HStack space="sm" className="items-center">
                            <IconM size={24} name={getIcon(name)} />
                            {index === props.state.index ? <Text className={`font-bold ${!is_nested ? 'text-md' : 'text-sm'} text-secondary-900`}>{i18n.t('studio.sideNavigationBar.' + name)}</Text> : <Text className={`${!is_nested ? 'text-md' : 'text-sm'} text-secondary-900`}>{i18n.t('studio.sideNavigationBar.' + name)}</Text>}
                        </HStack>
                    </View>
                </Pressable>
            );
        };

        const nestedLists = [
            // This assumes that the element within `SideBar` are in a logical order.
            { parent: 'contacts', nested: ['channels'] }

            // Add other sube menus
            // [...]
        ];

        return (
            <VStack space="xs" className="flex-1 bg-secondary-50">
                <DrawerContentScrollView {...props} contentContainerStyle={{ padding: 0 }}>
                    <VStack>
                        {props.state.routeNames
                            .filter((name) => {
                                return !['AppView', 'blank', 'legal'].includes(name);
                            })
                            .map((name, index) => {
                                const activeName = props.state.routeNames[props.state.index];
                                const isActive = activeName === name;

                                for (const rule of nestedLists) {
                                    if (!rule.nested.includes(name)) continue;

                                    // ---
                                    // FIXME(@Milo): This is generally bad. It should follow the
                                    //               ARIA pattern for menus and collabsalbe regions
                                    if (
                                        !(
                                            // ? skip if the parent, itself, nor siblings have focus
                                            (rule.parent === activeName || rule.nested.includes(activeName))
                                        )
                                    ) {
                                        return (
                                            <Box key={`${name}_${index}`} className="hidden">
                                                {/* keep item hidden/collapsed */}
                                            </Box>
                                        );
                                    }
                                    // ---

                                    // ? render as sub-item
                                    return renderSideMenuItem({ name, is_active: isActive, is_nested: true }, index);
                                }

                                return renderSideMenuItem({ name, is_active: isActive, is_active_parent: false }, index);
                            })}
                    </VStack>
                </DrawerContentScrollView>

                <HStack space="xl" className="my-3 mb-6" style={{ justifyContent: 'space-evenly' }}>
                    <IconM size={48} className='text-primary-900' onPress={() => props.navigation.navigate('legal')} name="security" />
                    <IconM size={48} className='text-primary-900' onPress={() => setShowHelpModal(true)} name="help-outline" />
                </HStack>

                <HelpModal showModal={showHelpModal} setShowModal={setShowHelpModal} />
                {/* <WelcomeModal showModal={showWelcomeModal} setShowModal={setShowWelcomeModal} /> */}
            </VStack>
        );
    }

    return (
        <SideBar.Navigator
            initialRouteName="home"
            screenOptions={{
                title: 'InA.Studio',
                headerShown: false,
                drawerType: 'permanent',
                drawerStyle: { width: 200 },
                drawerContentContainerStyle: { padding: 0 }
            }}
            drawerContent={(props) => <CustomDrawerContent {...props} />}>
            {/* menu items */}
            <SideBar.Screen name="home" component={Home} />
            <SideBar.Screen name="contacts" component={Contacts} />
            <SideBar.Screen name="channels" component={Channels} />
            <SideBar.Screen name="community" component={Community} />

            {/* system items */}
            {internal && <SideBar.Screen name="admin" component={ModalAdmin} />}

            {/*<SideBar.Screen name='planner' component={Blank}/>*/}
            {/*<SideBar.Screen name='statistics' component={Blank}/>*/}
            {/*<SideBar.Screen name='blank' component={Blank} />*/}

            {/* static icons */}
            <SideBar.Screen name="legal" component={LegalTabs} options={{ unmountOnBlur: true }} />
            <SideBar.Screen name="AppView" component={AppView} options={{ unmountOnBlur: true }} />
        </SideBar.Navigator>
    );
}
